"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var PALETTE_SCALE_MODE_ENUM = Object.freeze({
  AUTO: "PSM_AUTO",
  ADJUSTABLE: "PSM_FIX_BOTH"
});
var _default = exports.default = PALETTE_SCALE_MODE_ENUM;